export const isDev = import.meta.env.VITE_APP_ENV === "development";
